export const CardId = Object.freeze({
	Default: 'default',
	Unconfirmed: 'unconfirmed',
	Confirmed: 'confirmed',
	Late: 'late',
	Waitlist: 'waitlist',
	Overbooking: 'overbooking',
});
